import React, { useMemo } from "react";
import dayjs from "dayjs";
import { formatDate, formatTime } from "utils/formatters";
import DataTable from "./DataTable";

const DATE_GROUP_COLUMN = "historyDate";
const DATE_GROUPING = [DATE_GROUP_COLUMN];
const timeCell = ({ row }) => formatTime(row.original.changedAt);

export default function HistoryByDateTable({ columns, data, initialState = {} }) {
  const sortedData = useMemo(() => {
    const timestamp = (record) => {
      const date = record.changedAt ? dayjs(record.changedAt) : null;
      return date?.isValid() ? date.valueOf() : -Infinity;
    };

    return [...(Array.isArray(data) ? data : [])].sort(
      (a, b) => timestamp(b) - timestamp(a),
    );
  }, [data]);

  const groupedColumns = useMemo(() => [
    {
      id: DATE_GROUP_COLUMN,
      header: "Thời gian",
      accessorFn: (record) => {
        const date = record.changedAt ? dayjs(record.changedAt) : null;
        return date?.isValid() ? date.format("YYYY-MM-DD") : "";
      },
      enableHiding: false,
      size: 160,
      Cell: timeCell,
      PlaceholderCell: timeCell,
      GroupedCell: ({ cell, row }) => (
        <strong>{formatDate(cell.getValue())} ({row.subRows.length} thay đổi)</strong>
      ),
    },
    ...columns,
  ], [columns]);

  return (
    <DataTable
      columns={groupedColumns}
      data={sortedData}
      enableGrouping
      enableExpanding
      enableColumnDragging={false}
      groupedColumnMode={false}
      filterFromLeafRows
      paginateExpandedRows={false}
      initialState={{ ...initialState, expanded: false }}
      state={{ grouping: DATE_GROUPING }}
      muiTableBodyRowProps={({ row }) => ({
        sx: row.getIsGrouped() ? { backgroundColor: "#f6f9fc" } : {},
      })}
    />
  );
}
